import { PanelUserAccessScope } from "@bprotsyk/aso-core";

const USER_ROLE_STORAGE_KEY = "userRole";

export function readStoredRoles(): number[] {
  const rawRoles = localStorage.getItem(USER_ROLE_STORAGE_KEY);
  if (!rawRoles) {
    return [];
  }

  try {
    const parsed = JSON.parse(rawRoles);
    return Array.isArray(parsed) ? parsed.map((role) => Number(role)).filter((role) => Number.isFinite(role)) : [];
  } catch (_) {
    return [];
  }
}

export function getDefaultPanelPath(roles: number[] = readStoredRoles()): string {
  if (roles.includes(Number(PanelUserAccessScope.ADMIN)) || roles.includes(Number(PanelUserAccessScope.TESTER))) {
    return "/apps";
  }

  if (roles.includes(Number(PanelUserAccessScope.DEPLOYER))) {
    return "/domains";
  }

  if (roles.includes(Number(PanelUserAccessScope.CAPS_RW))) {
    return "/caps";
  }

  if (roles.includes(Number(PanelUserAccessScope.MANAGER))) {
    return "/app-info";
  }

  return "/auth";
}
